import Component from 'components/pages/Security/Security';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  fullPage: true,
  metaData: {
    title: 'Security',
    description: 'Report security problems with the Qmee site and apps.',
  },
});
